import React from 'react';
import TopBar from "./TopBar";
import Navbar from "./Navbar";
import Footer from "./Footer";
import AboutUsSection from "./AboutUsSection";

const AboutUs = () => {
    return (
        <>
            <TopBar/>
            <Navbar/>
            <AboutUsSection/>
            <Footer/>
        </>
    );
};

export default AboutUs;